<template>
    <validation-observer v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(handleSuggestChange)" class="suggestion-form">
        <p class="info">{{$t("portfolioManager.suggestOptimalization.note")}}</p>
        <validation-provider
          v-slot="{ failed, errors }"
          rules="required"
          name="objective"
        >
          <select-box
            :hasError="failed"
            :helperText="errors[0]"
            label="name"
            :name="$t('portfolioManager.suggestOptimalization.objective')"
            v-model="objective"
            :options="objectiveOptions"
            :clearable="false"
          />
        </validation-provider>
        <validation-provider
            v-slot="{ failed, errors }"
            :rules="`required|max_value:${portfolio.portfolio_input.custom_portfolio.length}`"
            class="number-of-assets"
        >
            <simple-form-input
              :hasError="failed"
              :helperText="errors[0]"
              :label="$t('portfolioManager.suggestOptimalization.numberOfAssets')"
              v-model="assetsNumber"
              type="number"
              step="1"
              hideTrailingIconUnfocused
            />
        </validation-provider>
        <b-button variant="primary" type="submit" :disabled="isCalculatingSuggestion">
            <change-icon />
            {{$t("portfolioManager.suggestOptimalization.suggestChange")}}
        </b-button>
      </form>
    </validation-observer>
  </template>
  
  <script>
  import { mapActions, mapGetters} from "vuex";
  import ChangeIcon from "vue-material-design-icons/SwapVerticalVariant.vue";
  import {
    OBJECTIVE_OPTIONS,
  } from "../../utils/constants";
  import SelectBox from "../inputs/SelectBox.vue";
  import SimpleFormInput from "../inputs/SimpleFormInput.vue";
  export default {
    components: { SelectBox, SimpleFormInput, ChangeIcon },
    name: "suggest-form",
    data() {
      return {
        assetsNumber: null,
        objectiveOptions: OBJECTIVE_OPTIONS(),
        objective: OBJECTIVE_OPTIONS()[0],
      };
    },
    methods: {
      ...mapActions("portfolioManagerStore", ["replaceStocksOptimalization"]),
      handleSuggestChange(){
        const params = {
            objective: this.objective,
            count_replace_assets: this.assetsNumber
        }
        this.replaceStocksOptimalization(params);
      }
    },
    computed: {
        ...mapGetters("portfolioManagerStore", ["portfolio", "isCalculatingSuggestion"])
      
    },
    watch: {
     
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .suggestion-form{
    display: flex;
    align-items: center;
    .info{
        margin: 0;
        width: fit-content;
        margin-right: 12px;
    }
    .btn{
        margin-bottom: 0.75rem;
        margin-left: toRem(5);
    }
    .selectbox-root{
      margin-right: toRem(5);
      min-width: toRem(150);
    }
    .number-of-assets{
      .input-root{
        width: 8vw;
        min-width: toRem(110);
        max-width: toRem(125);
      }
    }
  }
  </style>